// removed by extract-text-webpack-plugin
module.exports = {"wishInput":"_2BZnBijCS7WXbGNKgt8RiF","userImage":"_3tn9Qh3gHCd04WCA6VwCgY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateWish/css/CreateWishCard.css
// module id = 306
// module chunks = 0